<div class="casino-image-loader">
    @if (isLegacy) {
        @if (!disableLazyLoading && isDll && !enableFallback) {
            <img
                alt="no-fallback"
                [style]="computedStyle()"
                [lazyLoad]="src()"
                [defaultImage]="isImageLoaded ? src() : defaultSrc"
                [ngClass]="{ 'game-image-block-version': isBlockModuleVersion(), 'game-image-default-version': !isBlockModuleVersion() }"
                (onStateChange)="onImageStateChanged($event)"
                (error)="onGameIconError(src())" />
        } @else {
            <img alt="disableLazy" [src]="src()" (error)="onGameIconError(src())" />
        }
    }
</div>
